global.gConfig = {
  "environment": process.env.REACT_APP_STAGE || 'development',
  "apiUrl": "https://ifundapi.azurewebsites.net",
  "webUrl": process.env.REACT_APP_IFUND2_URL,
  "apiKey": "kPsnBymCZGuqf8XH{EmPCWRUcu7rcGPbqppx"
}